import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import SadIcon from 'assets/icons/emojis/sad.svg';
import BadIcon from 'assets/icons/emojis/bad.svg';
import HappyIcon from 'assets/icons/emojis/happy.svg';
import './style.css';

const emojis = [
  { value: 'somewhat_aggresive', icon: SadIcon },
  { value: 'very_aggressive', icon: BadIcon },
  { value: 'not_aggressive', icon: HappyIcon },
];

const TreatmentFeedback = ({ treatment, onSelect }) => {
  const { t } = useTranslation();
  const { id } = treatment;

  return (
    <div className="treatment-feedback">
      <h3 className="feedback-title">{t('events_widget.feedback.title')}</h3>
      <ul className="emoji-list">
        {emojis.map((emojy, index) => (
          <li key={index} onClick={() => onSelect(id, emojy.value)}>
            <img src={emojy.icon} alt="icon" />
          </li>
        ))}
      </ul>
    </div>
  );
};

TreatmentFeedback.propTypes = {
  onSelect: PropTypes.func.isRequired,
  treatment: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default TreatmentFeedback;
